import {
  FETCH_SUB_PETTY_CASH_REQUEST,
  FETCH_SUB_PETTY_CASH_SUCCESS,
  FETCH_SUB_PETTY_CASH_FAILURE,
  CREATE_SUB_PETTY_CASH_REQUEST,
  CREATE_SUB_PETTY_CASH_SUCCESS,
  CREATE_SUB_PETTY_CASH_FAILURE,
  UPDATE_SUB_PETTY_CASH_REQUEST,
  UPDATE_SUB_PETTY_CASH_SUCCESS,
  UPDATE_SUB_PETTY_CASH_FAILURE,
  DELETE_SUB_PETTY_CASH_REQUEST,
  DELETE_SUB_PETTY_CASH_SUCCESS,
  DELETE_SUB_PETTY_CASH_FAILURE,
  FETCH_SUB_PETTY_CASH_DAILY_FLOW_REQUEST,
  FETCH_SUB_PETTY_CASH_DAILY_FLOW_SUCCESS,
  FETCH_SUB_PETTY_CASH_DAILY_FLOW_FAILURE,
} from '../../Action/SubPettyCashAction/SubPettyCashAction';

const initialState = {
  transactions: [],
  total: 0,
  dailyFlow: null,
  loading: false,
  actionLoading: false,
  error: null,
};

const subPettyCashReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Transactions
    case FETCH_SUB_PETTY_CASH_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SUB_PETTY_CASH_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.transactions || [],
        total: action.payload.total || 0,
      };
    case FETCH_SUB_PETTY_CASH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch Daily Cash Flow
    case FETCH_SUB_PETTY_CASH_DAILY_FLOW_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SUB_PETTY_CASH_DAILY_FLOW_SUCCESS:
      return { ...state, loading: false, dailyFlow: action.payload };
    case FETCH_SUB_PETTY_CASH_DAILY_FLOW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Create / Fund Transfer / Hand Over (all funnel through the same
    // CREATE_* types). Note: unlike PettyCashReducer, the backend only
    // returns { id, current_sub_petty_cash_balance } here (not a full
    // transaction row), and the UI (TransactionsList/CashFlowDashboard)
    // always re-fetches via onRefresh() after a successful create anyway —
    // so we just track loading/error here rather than optimistically
    // (and incorrectly) pushing a partial object into `transactions`.
    case CREATE_SUB_PETTY_CASH_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case CREATE_SUB_PETTY_CASH_SUCCESS:
      return { ...state, actionLoading: false };
    case CREATE_SUB_PETTY_CASH_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    // Update / Delete — same reasoning as Create above: UI re-fetches via
    // onRefresh() after success, so just track loading/error here.
    case UPDATE_SUB_PETTY_CASH_REQUEST:
    case DELETE_SUB_PETTY_CASH_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case UPDATE_SUB_PETTY_CASH_SUCCESS:
    case DELETE_SUB_PETTY_CASH_SUCCESS:
      return { ...state, actionLoading: false };
    case UPDATE_SUB_PETTY_CASH_FAILURE:
    case DELETE_SUB_PETTY_CASH_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default subPettyCashReducer;